module.exports = __webpack_public_path__ + "assets/img/14_947_big.7732dcbb.jpg";